// gridSchemaEnhancer.jsx
import messages from '../../../messages';

export const gridSchemaEnhancer = ({ schema, formData, intl }) => {
  const isThisVariation =
    formData?.variation === 'fcmhGrid' || formData?.template === 'fcmhGrid';

  if (!isThisVariation) return schema;

  schema.properties.moreLinkLabel = {
    title: 'Footer-Text:',
    type: 'string',
    default: 'Weitere Beiträge anzeigen',
  };

  schema.properties.moreLinkHref = {
    title: 'Footer-Link:',
    description: intl.formatMessage(messages.listingFootnote),
    widget: 'object_browser',
    mode: 'link',
  };

  schema.properties.styleVariant = {
    title: 'Stil',
    factory: 'Choice',
    choices: [
      ['default', 'Standard'],
      ['light', 'Weißer Hintergrund'],
    ],
    default: formData?.styleVariant || 'default',
  };

  const fs =
    schema.fieldsets?.find((f) => f.id === 'default') || schema.fieldsets?.[0];

  if (fs) {
    for (const f of ['styleVariant', 'moreLinkLabel', 'moreLinkHref']) {
      if (!fs.fields.includes(f)) fs.fields.push(f);
    }
  }

  return schema;
};
